var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Header"),
      _vm._v(" "),
      _c("div", { attrs: { id: "main" } }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row justify-content-between header" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-4" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn create-project",
                    attrs: { to: "/projects" }
                  },
                  [_vm._v("Realizar doação")]
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "btn create-project",
                    attrs: { to: "/descontosdobem" }
                  },
                  [_vm._v("Descontos do Bem")]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }),
          _vm._v(" "),
          _vm.user
            ? _c("div", { staticClass: "row" }, [
                _vm.donations && _vm.donations.length > 0
                  ? _c("table", { staticClass: "donations table" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.donations, function(d) {
                          return _c("tr", { key: d.DonationId }, [
                            _c("td", [
                              _vm._v(_vm._s(_vm.getDate(d.timestamp)))
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  d.Project.Info ? d.Project.Info.title : ""
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [_vm._v("R$ " + _vm._s(d.value))]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  d.type == "single" ? "Simples" : "Recorrente"
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(_vm._s(_vm.getStatus(d.paymentStatus)))
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "a",
                                {
                                  attrs: { href: "" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      $event.preventDefault()
                                      return _vm.showDonationDetail(d)
                                    }
                                  }
                                },
                                [_vm._v("Ver Detalhes")]
                              )
                            ])
                          ])
                        }),
                        0
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.donations && _vm.donations.length == 0
                  ? _c(
                      "h4",
                      { staticClass: "projects-empty" },
                      [
                        _vm._v("Você não possui doações. Clique "),
                        _c("router-link", { attrs: { to: "/projects" } }, [
                          _vm._v("aqui")
                        ]),
                        _vm._v(" para fazer uma doação!")
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("Footer"),
      _vm._v(" "),
      _vm.loading
        ? _c("Loading", {
            attrs: { message: "Aguarde, estamos atualizando seu extrato..." }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "donationDetail",
          attrs: { "hide-footer": "", title: "Detalhes da Doação" }
        },
        [
          _vm.donationModal
            ? _c("div", { staticClass: "d-block text-center" }, [
                _c("h3", [
                  _vm._v(
                    "Projeto: " +
                      _vm._s(
                        _vm.donationModal.Project.Info
                          ? _vm.donationModal.Project.Info.title
                          : ""
                      )
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("Valor: R$ " + _vm._s(_vm.donationModal.value))
                ]),
                _vm._v(" "),
                _vm.donationModal.paymentMethod
                  ? _c("p", [
                      _vm._v(
                        "Forma de pagamento: " +
                          _vm._s(_vm.donationModal.paymentMethod)
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Tipo de Doação: " +
                      _vm._s(
                        _vm.donationModal.type == "single"
                          ? "Simples"
                          : "Recorrente"
                      )
                  )
                ]),
                _vm._v(" "),
                _vm.donationModal.paymentMethod
                  ? _c("p", [
                      _vm._v(
                        "Forma de Pagamento: " +
                          _vm._s(_vm.donationModal.paymentMethod) +
                          " / " +
                          _vm._s(_vm.donationModal.paymentType)
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Status: " +
                      _vm._s(_vm.getStatus(_vm.donationModal.paymentStatus))
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-btn",
            {
              staticClass: "mt-3",
              attrs: { variant: "outline-danger", block: "" },
              on: { click: _vm.hideModal }
            },
            [_vm._v("Fechar")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8" }, [
      _c("h2", [_vm._v("Extrato Social")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Doações recorrentes estão exibindo apenas o valor doado no primeiro mês"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("th", [_vm._v("Data")]),
      _vm._v(" "),
      _c("th", [_vm._v("Projeto")]),
      _vm._v(" "),
      _c("th", [_vm._v("Valor")]),
      _vm._v(" "),
      _c("th", [_vm._v("Tipo")]),
      _vm._v(" "),
      _c("th", [_vm._v("Situação")]),
      _vm._v(" "),
      _c("th", [_vm._v("Detalhes")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a4602b56", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4602b56","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyDonations.vue
// module id = null
// module chunks = 